import { IApplicationState } from '../../types/redux';

export function isReliableSelector(state: IApplicationState) {
  return !!state.newbuilding.isReliable;
}

export function getReliabilityText(state: IApplicationState) {
  return state.newbuilding.reliabilityText;
}

export function isReliableHouseSelector(state: IApplicationState) {
  const selectedHouseId = state.offers?.selectedHouseId;

  if (selectedHouseId) {
    const selectedHouse = state.newbuilding.houses.find(house => house.houseId === selectedHouseId);

    return selectedHouse?.isReliable || false;
  }

  return state.newbuilding.isReliable;
}
